export default function PageHeader({ eyebrow, title, description, actions, testid }) {
  return (
    <div className="border-b border-neutral-200 bg-white" data-testid={testid}>
      <div className="px-8 py-8 flex flex-wrap items-end justify-between gap-6">
        <div>
          {eyebrow && (
            <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#002FA7] mb-2">{eyebrow}</div>
          )}
          <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter leading-none">{title}</h1>
          {description && (
            <p className="mt-3 text-sm text-neutral-600 max-w-xl">{description}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
